import type { MockupSize } from "./MockupScene.types";

export const mockupSizeClasses: Record<MockupSize, string> = {
  bento: "h-[240px] min-h-[240px]",
  hero: "h-[400px] min-h-[400px]",
  full: "h-[480px] min-h-[480px]",
  fill: "h-full min-h-0",
};

/** Design canvas width before bento scale transform */
export const MOCKUP_BENTO_CANVAS_WIDTH = 640;

export const MOCKUP_BENTO_SCALE = 0.62;
